import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import analytics from '@finn-no/analytics';

export default function CmsBox({ title, imageUrl, url, buttonText, index, trackCmsClick, assetUrl }) {
    const completeImageUrl = `${assetUrl || FINN.travel.cdnBaseUrl + FINN.travel.contextPath}assets/img/hq/${imageUrl}`;

    const track = () => {
        // As this is a shared component (frontpage & flight), it might not get a trackCmsClick handler
        // (remove check when the CMS boxes are removed from flight search page)
        if (trackCmsClick) {
            trackCmsClick(title, url, index);
        }

        return analytics.trackEvent({
            analyticsName: 'promotions.click-promotion.done',
            stringValue: `cmslink${index + 1}`,
        });
    };

    return (
        <a className="employer-preview__click-area" href={url} target="_blank" onClick={track} data-testid={`cmsBox${index}`}>
            <div className="employer-preview__media">
                <div className="img-format img-format--ratio4by3 img-format--crop-vertical img-format--centered">
                    <LazyLoad height={200} offset={300}>
                        <img className="img-format__img" src={completeImageUrl} alt={title} />
                    </LazyLoad>
                </div>
            </div>
            <div className="employer-preview__text u-d1">
                <div className="employer-preview__text__description u-pt8">
                    <h3 className="employer-preview__heading">{title}</h3>
                    <p className="employer-preview__subheading">{buttonText}</p>
                </div>
            </div>
        </a>
    );
}

CmsBox.propTypes = {
    title: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    buttonText: PropTypes.string,
    index: PropTypes.number.isRequired,
    trackCmsClick: PropTypes.func,
    assetUrl: PropTypes.string,
};
